import './styles/themes.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ChatLayout from './components/ChatLayout';
import Login from './pages/Login';
import { useAuthStore } from './stores/auth';
import { UserRole } from './types/roles';
import { ThemeProvider } from './context/ThemeContext';
import AdminDashboard from './components/admin/AdminDashboard';
import Home from './pages/Home';
import PaynowReturn from './pages/PaynowReturn';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AdminLayout } from './components/admin/AdminLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
// import { QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useAuthInitialization } from './hooks/useAuthInitialization';
import { Toaster } from 'react-hot-toast';

const App = () => {
  const { user, isAuthenticated } = useAuthStore();
  const isLoading = useAuthStore((state) => state.loading.login);
  const { isInitialized } = useAuthInitialization();

  console.log('Current user state:', {
    user,
    isAuthenticated,
    isLoading,
    isInitialized,
    userExists: !!user,
    fullUserObject: JSON.stringify(user, null, 2)
  });

  // Show loading while initializing auth
  if (!isInitialized || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0f172a] to-[#1e293b]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-400 mx-auto mb-4"></div>
          <div className="text-slate-300">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <Toaster position="top-right" />
      {/* <QueryClientProvider client={queryClient}> */}
        <ThemeProvider>
          <Routes>
            <Route
              path="/"
              element={<Home />}
            />
            
            <Route 
              path="/login" 
              element={
                isAuthenticated && user ? (
                  <Navigate to={user.role === UserRole.ADMIN ? "/admin" : "/chat"} replace />
                ) : (
                  <Login />
                )
              } 
            />

            <Route
              path="/admin"
              element={
                <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
                  <AdminLayout>
                    <AdminDashboard userRole={user?.role || UserRole.USER} />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/chat"
              element={
                <ProtectedRoute allowedRoles={[UserRole.USER]}>
                  <Layout userRole={user?.role || UserRole.USER}>
                    <ChatLayout 
                      userRole={user?.role || UserRole.USER}
                      selectedSubject={null}
                      onSubjectSelect={() => {}}
                      selectedThreadId={null}
                      onThreadSelect={() => {}}
                      selectedProjectId={null}
                      onProjectSelect={() => {}}
                    />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/payments/paynow/return"
              element={
                <ProtectedRoute allowedRoles={[UserRole.USER, UserRole.ADMIN]}>
                  <PaynowReturn />
                </ProtectedRoute>
              }
            />
          </Routes>
        </ThemeProvider>
        {/* <ReactQueryDevtools />
      </QueryClientProvider> */}
    </ErrorBoundary>
  );
};

export default App;
